/**
  * 用户模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const userApi = {
    GetUserList: `${base.qa}/User/GetUserList`,
    DelUser: `${base.qa}/User/DelUser`,
    ResetPwd: `${base.qa}/User/ResetPwd`,//重置密码
    IsEnableUser: `${base.qa}/User/IsEnableUser`,//设置启用状态
    ImportUser: `${base.qa}/User/ImportUser`,//导入用户信息
    GetImportTemp: `${base.qa}/User/GetImportTemp`,//导入模板下載
    ExportUser: `${base.qa}/User/ExportUser`,//导出用户
    UpdateClass: `${base.qa}/User/UpdateClass`,//批量修改学生班级

    GetUserDataTree: `${base.qa}/RoleUserModule/GetUserDataTree`,
    SaveUserData: `${base.qa}/RoleUserModule/SaveUserData`,

    GetUserModuleAndBtns: `${base.qa}/RoleUserModule/GetUserModuleAndBtns`,
    SaveUserButtons: `${base.qa}/RoleUserModule/SaveUserButtons`,
}

const user = {
    GetUserList (params) {
        return axios.get(userApi.GetUserList, { params: { pageindex: params.pageindex, pagesize: params.pagesize, roleid: params.roleid, specid: params.specid, classid: params.classid, keyword: params.keyword } })
    },
    DelUser (params) {
        return axios.post(userApi.DelUser, params)
    },
    ResetPwd (params) {
        return axios.get(userApi.ResetPwd, { params: { userid: params } })
    },
    IsEnableUser (params) {
        return axios.post(userApi.IsEnableUser, params)
    },
    ImportUser (params) {
        return axios.post(userApi.ImportUser, params)
    },
    GetImportTemp (params) {
        return axios.get(userApi.GetImportTemp)
    },
    ExportUser (params) {
        let _newPar = {}
        for (const key in params) {
            if ((params[key] === 0 || params[key] === false || params[key]) && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
                _newPar[key] = params[key];
            }
        }
        return axios.get(userApi.ExportUser, { params: { roleid: _newPar.roleid, specid: _newPar.specid, classid: _newPar.classid, keyword: _newPar.keyword } })
    },
    UpdateClass (params) {
        return axios.post(userApi.UpdateClass, params)
    },
    GetUserDataTree (params) {
        return axios.get(userApi.GetUserDataTree, { params: { userid: params } })
    },
    SaveUserData (params) {
        return axios.post(userApi.SaveUserData, params)
    },

    GetUserModuleAndBtns (params) {
        return axios.get(userApi.GetUserModuleAndBtns, { params: { userid: params } })
    },
    SaveUserButtons (params) {
        return axios.post(userApi.SaveUserButtons, params)
    },
}


export default user;